const KEY = 'cv-portal:show-experimental';

export const getShowExperimental = (): boolean =>
    localStorage.getItem(KEY) === 'true';

export const setShowExperimental = (value: boolean): void =>
    localStorage.setItem(KEY, String(value));
